import React from "react";
import { comparisons } from "../data/landing";
export function DifferenceSection() {
  return <section className="border-b border-line bg-surface" data-id="element-44" data-mp="1b2h7eom1zia2">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28" data-id="element-45" data-mp="1b41w3xlos700">
        <div className="max-w-3xl" data-id="element-46" data-mp="1p2jjfu7ojhhe">
          <h2 className="font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-47" data-mp="1ozdssajek7jk">
            Su enfoque no es fantasioso. <span className="text-gold" data-id="element-48" data-mp="1y2exc6smdql4">Es táctico.</span>
          </h2>
          <p className="mt-6 leading-relaxed text-muted" data-id="element-49" data-mp="1y0lnkimpmq8w">
            La mayoría de los libros de abundancia fueron pensados para contextos que no se
            parecen al nuestro. Este fue creado para personas reales, con preocupaciones reales,
            en un país donde la estabilidad muchas veces se construye desde adentro hacia afuera.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-line" data-id="element-50" data-mp="2hr78m0vjur08">
          <table className="w-full text-left" data-id="element-51" data-mp="2cs436fbnqirq">
            <thead data-id="element-52" data-mp="2cp858qzt7u3a">
              <tr className="border-b border-line" data-id="element-53" data-mp="2frnm1ji67jlo">
                <th scope="col" className="w-1/2 px-6 py-4 text-sm font-medium text-muted" data-id="element-54" data-mp="2fsyx84dy3tmt">
                  Otros libros de abundancia
                </th>
                <th scope="col" className="w-1/2 bg-emerald-deep px-6 py-4 text-sm font-medium text-gold" data-id="element-55" data-mp="2oslpo0op5p3q">
                  Mindset Anti-Fragilidad
                </th>
              </tr>
            </thead>
            <tbody data-id="element-56" data-mp="2yq9ph515tmsr">
              {comparisons.map(row => <tr key={row.others} className="border-b border-line last:border-b-0" data-id="element-57" data-mp="33okxrbbt3p8v">
                  <td className="px-6 py-5 align-top text-muted" data-id="element-58" data-mp="38g2wdsqcxdqo">{row.others}…</td>
                  <td className="bg-emerald-deep px-6 py-5 align-top text-cream" data-id="element-59" data-mp="3chohu2gyj0ch">{row.ours}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}